import { useEffect } from "react";
import "@/App.css";
import { initLenis, destroyLenis } from "@/lib/scroll";
import { Header } from "@/components/Header";
import { GenieMascot } from "@/components/GenieMascot";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { HowItWorks } from "@/components/HowItWorks";
import { WhyRenoGenie } from "@/components/WhyRenoGenie";
import { Showcase } from "@/components/Showcase";
import { FinalCTA } from "@/components/FinalCTA";
import { AppPrelaunch } from "@/components/AppPrelaunch";
import { Footer } from "@/components/Footer";
import { MagicPath } from "@/components/MagicPath";

function App() {
    useEffect(() => {
        initLenis();
        return () => destroyLenis();
    }, []);

    return (
        <div className="App bg-white text-brand-deep">
            <Header />
            <GenieMascot />
            <main id="page-root" className="relative">
                <Hero />
                <Marquee />
                <Services />
                <HowItWorks />
                <WhyRenoGenie />
                <Showcase />
                <FinalCTA />
                <AppPrelaunch />
                <Footer />
                <MagicPath />
            </main>
        </div>
    );
}

export default App;
